import { render, staticRenderFns } from "./PostSroMenu.vue?vue&type=template&id=fe3325dc"
import script from "./PostSroMenu.vue?vue&type=script&lang=js"
export * from "./PostSroMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports